import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from './Toast';
import Modal from './Modal';

const UIContext = createContext();

export const UIProvider = ({ children }) => {
    // Toast State
    const [toast, setToast] = useState({ message: '', type: 'info', visible: false });

    // Modal State
    const [modal, setModal] = useState({
        title: '',
        content: null,
        actions: null,
        visible: false,
        onClose: null,
        closeLabel: 'Close modal',
        containerClassName: '',
        bodyClassName: ''
    });

    // --- Toast Methods ---
    const showToast = useCallback((message, type = 'info') => {
        setToast({ message, type, visible: true });
    }, []);

    const hideToast = useCallback(() => {
        setToast((prev) => ({ ...prev, visible: false }));
    }, []);

    // --- Modal Methods ---
    const showModal = useCallback(
        ({ title, content, actions, onClose, closeLabel, containerClassName, bodyClassName }) => {
            setModal({
                title,
                content,
                actions,
                visible: true,
                onClose: onClose || null,
                closeLabel: closeLabel || 'Close modal',
                containerClassName: containerClassName || '',
                bodyClassName: bodyClassName || ''
            });
        },
        []
    );

    const hideModal = useCallback(() => {
        if (modal.onClose) modal.onClose();
        setModal((prev) => ({ ...prev, visible: false }));
    }, [modal]);

    return (
        <UIContext.Provider value={{ showToast, hideToast, showModal, hideModal }}>
            {children}

            {/* Global Toast Render */}
            {toast.visible && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={hideToast}
                />
            )}

            {/* Global Modal Render */}
            <Modal
                isOpen={modal.visible}
                title={modal.title}
                actions={modal.actions}
                closeLabel={modal.closeLabel}
                containerClassName={modal.containerClassName}
                bodyClassName={modal.bodyClassName}
                onClose={hideModal}
            >
                {modal.content}
            </Modal>
        </UIContext.Provider>
    );
};

export const useUI = () => useContext(UIContext);
